/* eslint-disable no-param-reassign */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable class-methods-use-this */
import * as Services from '@services';
import { makeAutoObservable, runInAction } from 'mobx';

class DocumentStore {
  documentSasUrl: string = '';

  constructor() {
    makeAutoObservable(this);
  }

  async get(entityDto: Services.EntityDto<string>) {
    return await Services.DocumentService.get(entityDto);
  }

  async getDocumentSasUrl() {
    try {
      const result = await Services.DocumentService.getDocumentSasUrl();
      runInAction(() => {
        this.documentSasUrl = result;
      });
    } catch (error) {
      console.error(error);
    }
  }
}

export default DocumentStore;
